import { t } from "i18next";

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('frm-packetEditOpenNetworkForm-form')) {
        Array.from(document.getElementsByClassName('toggleDelete')).forEach((button) => {
            button.onclick = (e) => {
                e.preventDefault()
                const photoId = button.getAttribute('data-photo-id')
                const textContainer = document.getElementById('deletePhoto' + photoId)
                const deleteInput = document.getElementById(button.getAttribute('data-target-hidden'))
                if(textContainer.style.visibility === '') {
                    textContainer.style.visibility = 'visible';
                    textContainer.style.display = null;
                    button.value = t('global.ui.cancel')
                    deleteInput.value = 1;
                } else {
                    textContainer.style.visibility = null;
                    textContainer.style.display = 'none';
                    button.value = t('global.ui.delete')
                    deleteInput.value = 0;
                }
            }
        })
    }
});